import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useLocation } from "react-router-dom";

export default function AddEditCarouselImage() {
  const navigate = useNavigate();
  const { id } = useParams(); 
  const isEdit = Boolean(id);
  const location = useLocation();

  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
  if (isEdit && location.state?.imageUrl) {
    setImageUrl(location.state.imageUrl);
  }
}, [isEdit, location.state]);



const handleSubmit = async () => {
  if (!imageUrl) return alert("Image URL required");

  try {
    if (isEdit) {
      await axios.put(
        `https://api.livestockify.com/api/admin/carousel/${id}`,
        {
          id,
          imageUrl,
        }
      );
    } else {
      await axios.post(
        "https://api.livestockify.com/api/admin/carousel",
        { imageUrl }
      );
    }

    navigate("/uploads/carousel");
  } catch (err) {
    console.error(err);
    alert("Update failed");
  }
};


  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-8 pl-14 md:pl-8">
        {/* HEADER */}
        <h1 className="text-lg font-semibold text-green-700 mb-8">
          {isEdit ? "Edit Carousel Image" : "Add Carousel Image"}
        </h1>

        <div className="flex justify-center">
          <div className="w-full max-w-3xl">
            {/* IMAGE URL FIELD */}
            <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] items-start md:items-center gap-3 md:gap-6 mb-8 md:mb-10">
              <label className="text-sm font-medium text-gray-700 md:text-right">
                Image URL
              </label>

              <input
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
                placeholder="Enter Image URL"
                className="w-full md:max-w-[420px] border rounded-md px-3 py-2 text-sm
focus:outline-none focus:ring-1 focus:ring-green-500"
              />
            </div>

            {/* ACTION BUTTONS */}
            <div className="flex justify-end gap-4 max-w-[620px]">
              <button
                onClick={() => navigate("/uploads/carousel")}
                className="border px-6 py-2 rounded-md text-sm"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-6 py-2 rounded-md text-sm"
              >
                {isEdit ? "Update" : "Upload"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
